export const CATALOG = 'Catalog';
export const QUERY = `${CATALOG}/Query`;
export const COLLECTION = `${CATALOG}/Collection`;
export const NAVIGATION = `${CATALOG}/Navigation`;
export const PREVIEW = `${CATALOG}/Preview`;
